export default __webpack_public_path__ + "static/media/Design_Exceptions.626095ff.png";